
import { Component } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';
import { VueCssClasses } from '../../../utils';
import EmpathizePanel from './empathize-panel.vue';

@Component
export default class BlockEmpathizePanel extends EmpathizePanel {

  protected get cssClasses(): VueCssClasses {
    return [
      'ebx-empathize-panel--block',
      { 'ebx-empathize-panel--open': this.showEmpathize }
    ];
  }

  protected getPositionStyle(searchBoxElement: HTMLElement): Partial<CSSStyleDeclaration> {
    const inputBoundingClientRect = searchBoxElement.getBoundingClientRect();
    if (this.$el.parentElement) {
      const parentBoundingClientRect = this.$el.parentElement.getBoundingClientRect();
      return {
        paddingLeft: `${ inputBoundingClientRect.left - parentBoundingClientRect.left }px`,
        paddingRight: `${ parentBoundingClientRect.right - inputBoundingClientRect.right }px`
      };
    }
    return {
      paddingLeft: `${ inputBoundingClientRect.left }px`,
      paddingRight: `${ inputBoundingClientRect.right - inputBoundingClientRect.left - inputBoundingClientRect.width }px`
    };
  }

  onScroll() {
    this.$x.emit(EVENTS.EmpathizeScroll);
  }
}
